import { useEffect, useState } from 'react';

import AppButton from '../../../../commons/buttons/AppButton';
import AppContainer from '../../../../commons/containers/AppContainer';
import AppCurrencyInput from '../../../../commons/inputs/AppCurrencyInput';
import AppInput from '../../../../commons/inputs/AppInput';
import AppLinkButton from '../../../../commons/buttons/AppLinkButton';
import { Form } from 'react-bootstrap';
import HallAppToast from '../../../../commons/HallAppToast';
import { formatInReal } from '../../../../commons/util/HallAppUtil';

/* eslint-disable react-hooks/exhaustive-deps */
function HPStep3({ nextStep, toBack, ruleType, configToEdit }) {

    const [point, setPoint] = useState(0);
    const [value, setValue] = useState(0);

    const POINTS_FOR_VALUE = 'POINTS_FOR_VALUE'
    const POINTS_FOR_SERVICE = 'POINTS_FOR_SERVICE'
    const POINTS_FOR_PERCENTAGE = 'POINTS_FOR_PERCENTAGE'

    useEffect(() => {
        if (configToEdit != null && Object.keys(configToEdit).length > 0) {
            setPoint(configToEdit.pointsConfig.point)
            setValue(configToEdit.pointsConfig?.value)
        }
    }, []);


    const toNext = () => {

        if (ruleType === POINTS_FOR_VALUE && (point === 0 || value === 0)) {
            HallAppToast.error('Preencha os campos abaixo')
            return;
        }

        if (ruleType === POINTS_FOR_SERVICE && point === 0) {
            HallAppToast.error('Preencha o campo abaixo')
            return;
        }

        if (ruleType === POINTS_FOR_PERCENTAGE && (value === 0 || value === undefined)) {
            HallAppToast.error('Preencha os campos abaixo')
            return;
        }

        const data = {
            point: point,
            value: value
        }
        nextStep(data)
    };

    const getRuleTypeDescription = () => {
        if (ruleType === POINTS_FOR_VALUE) {
            return '[A] Pontos por valor gasto'
        }
        if (ruleType === POINTS_FOR_SERVICE) {
            return '[B] Pontos fixos por serviço'
        }
        if (ruleType === POINTS_FOR_PERCENTAGE) {
            return '[C] Pontos proporcionais ao valor gasto'
        }
    }

    const renderByValue = () => {
        return <div>
            <Form>
                <label>Quantos pontos o cliente ganha?</label>
                <AppInput
                    label="Pontos"
                    name="points"
                    type='number'
                    value={point}
                    errors={[]}
                    onChange={(e) => { setPoint(e.target.value) }} />

                <label>A cada quantos reais o cliente recebe os pontos?</label>
                <AppCurrencyInput
                    label="Valor"
                    name="value"
                    value={value}
                    errors={[]}
                    onChange={(_, value) => setValue(value)} />
            </Form>
            <hr></hr>

            <p>O(a) cliente vai ganhar {point} pontos á cada {formatInReal(value)} reais gastos.</p>
        </div>
    }

    const renderByService = () => {
        return <div>
            <Form>
                <label>Quantos pontos o cliente ganha?</label>
                <AppInput
                    label="Pontos"
                    name="points"
                    type='number'
                    value={point}
                    errors={[]}
                    onChange={(e) => { setPoint(e.target.value) }} />
            </Form>
            <hr></hr>

            <p>O(a) cliente vai ganhar {point} pontos á cada serviço realizado.</p>
        </div>
    }

    const renderByPercentage = () => {
        return <div>
            <Form>
                <label>A cada quantos % o cliente recebe os pontos?</label>
                <AppInput
                    label="Porcentagem"
                    name="percentage"
                    type='number'
                    errors={[]}
                    value={value}
                    onChange={(e) => { setValue(e.target.value) }} />
            </Form>
            <hr></hr>

            <p>O(a) cliente vai ganhar X pontos á cada {value}% sobre o valor do serviço realizado.</p>
        </div>
    }


    return (
        <div className="container">
            <h6>A opção escolhida foi: <br></br><b>{getRuleTypeDescription()}</b></h6>
            <hr></hr>

            {ruleType === POINTS_FOR_VALUE && renderByValue()}

            {ruleType === POINTS_FOR_SERVICE && renderByService()}

            {ruleType === POINTS_FOR_PERCENTAGE && renderByPercentage()}

            <div style={{ marginBottom: '220px' }}></div>


            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '0rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}
            >
                <AppContainer>
                    <AppLinkButton name="Próximo" fullWidth={true} onClick={toNext} />

                    <div style={{ marginTop: '10px' }}>
                        <AppButton name="voltar" width="100%" onClick={toBack} />
                    </div>
                </AppContainer>
            </div>
        </div>
    );
}

export default HPStep3;